var React = require('react');

function Basket (props) {
    return React.createElement("svg",props,React.createElement("g",{"opacity":"0.6"},[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1 8L3.90589 20H12.0349L15 8H1Z","stroke":"#382E2B","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M5.09657 8C4.67112 3.33333 5.65144 1 8.03752 1C10.4236 1 11.3683 3.33333 10.8716 8","stroke":"#382E2B","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]));
}

Basket.defaultProps = {"width":"16","height":"21","viewBox":"0 0 16 21","fill":"none"};

module.exports = Basket;

Basket.default = Basket;
